export default __webpack_public_path__ + "static/media/onboarding3.54824375.png";